import styled from 'styled-components';
import Form from 'antd/es/form';
import { Colors, FontSizes, FontWeights, Screens } from 'core/CssVariables';
import { TFormItemProps } from './types';

const { Item } = Form;
const SFormItem = styled(Item)`
  margin-bottom: ${(props: TFormItemProps) => props.marginBottom || 24}px;

  flex-direction: column;
  &.ant-form-item-with-help {
    margin-bottom: 0;
  }
  &.ant-form-item-has-error
    :not(.ant-input-disabled):not(.ant-input-borderless).ant-input {
    background-color: ${({ theme }) => theme.input.backgroundColor};
  }
  &.ant-form-item-has-error
    :not(.ant-input-affix-wrapper-disabled):not(
      .ant-input-affix-wrapper-borderless
    ).ant-input-affix-wrapper {
    background-color: ${({ theme }) => theme.input.backgroundColor};
  }
  .ant-form-item-control-input {
    textarea {
      border-radius: 4px;
      resize: none;
    }
    min-height: 30px;
  }
  .ant-form-item-label {
    text-align: left;
    label {
      font-size: ${FontSizes.FontXS}px;
      font-weight: ${FontWeights.Light};
      color: ${Colors.LightGrey};
      height: auto;
      &::after {
        content: '';
      }
    }
    .ant-form-item-required:not(.ant-form-item-required-mark-optional) {
      &:before {
        display: none;
      }
      /* !important is necessary here to override Ant Design's built-in
         required-marker styles (which apply their own ::before asterisk
         and have higher specificity within the antd stylesheet). */
      &::after {
        display: inline-block !important;
        margin-left: 2px;
        color: ${Colors.ErrorColor} !important;
        font-size: ${FontSizes.FontSM}px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*' !important;
      }
    }
  }
  /* Suppress the asterisk when the FormItem has a pre-populated default
     value (class added by FormItem/index.tsx). !important mirrors the
     rule it is overriding. */
  &.has-default-value .ant-form-item-label .ant-form-item-required::after {
    content: '' !important;
  }
  .ant-form-item-explain-error {
    font-size: ${FontSizes.FontXS}px;
    color: ${Colors.ErrorColor};
    @media (max-width: ${Screens.ScreensSM}) {
      display: flex;
    }
  }
`;

export default SFormItem;
